<template>
    <div class="profile_edit_content_block">
        <Breadcrumbs :type="type" :header="title" :url="url" :head="head"></Breadcrumbs>
        <trashed-message v-if="resident.deleted_at" class="mb-6" @restore="restore"> This resident has been deleted.
        </trashed-message>
        <div class="w-full bg-white rounded-md shadow overflow-hidden edit_form_block">
            <form @submit.prevent="update">
                <div class="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6 mt-3 p-4">
                    <div class="sm:col-span-3">
                        <div class="mt-1 flex items-center h-[225px]">
                            <div
                                class="mt-1 flex flex-wrap justify-center rounded-md border-2 border-dashed border-gray-300 dark:border-black dark:bg-white dark:text-black px-6 pt-5 pb-6">
                                <div class="space-y-1 text-center">
                                    <PhotoBlock :getPhoto="form.image_path" @SetPhoto="set_photo" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="sm:col-span-3"></div>
                    <text-input v-model="form.title" :error="form.errors.title" class="sm:col-span-2" label="Title"
                        required="true" placeholder="i.e. Anitya Cave House" @keyup="slugBuild" />
                    <text-input v-model="form.slug" :error="form.errors.slug" class="sm:col-span-2" label="Slug"
                        required="true" placeholder="i.e anitya-cave-house" />
                    <textarea-input v-model="form.desc" :error="form.errors.desc" class="sm:col-span-2"
                        label="Resident Description" required="true"
                        placeholder="i.e In the heart of Cappadocia, Ortahisar, a cavehouse of 80 square meter, fully equipped kitchen with a scenic terrace is offered for a relaxing and enjoyable vacation." />
                    <text-input v-model="form.longitude" :error="form.errors.longitude" class="sm:col-span-2"
                        label="Longitude" placeholder="i.e. 120.9842195" />
                    <text-input v-model="form.latitude" :error="form.errors.latitude" class="sm:col-span-2"
                        label="Latitude" placeholder="i.e. 14.5995124" />
                    <text-input v-model="form.google_address" :error="form.errors.google_address" class="sm:col-span-2"
                        label="Google Address" placeholder="i.e. Butig Proper, Butig, Lanao del Sur, Philippines" />

                    <TextareaInput v-model="form.map_embedded" :error="form.errors.map_embedded" class="sm:col-span-2"
                        label="Google Map" placeholder="i.e. https://goo.gl/maps/mjShJjfPKppUQBJs7" />

                    <template v-if="host_selected == false">
                        <select-input v-model="form.host_id" :error="form.errors.host_id" class="sm:col-span-2"
                            label="Host" required="true">
                            <option :value=null>Select Host</option>
                            <option v-for="host in hosts" :key="host.id" :value='host.id'>{{ host.full_name }}</option>
                        </select-input>
                    </template>
                    <text-input v-model="form.email" :error="form.errors.email" class="sm:col-span-2" label="Email"
                        :type="email" required="true" placeholder="i.e example@test.com" />
                    <text-input v-model="form.mobile" :error="form.errors.mobile" class="sm:col-span-2" label="Mobile"
                        placeholder="i.e +63-2-1234-5678" />
                    <status-toogle-button v-model="form.status" :error="form.errors.status" label="Resident Status"
                        class="sm:col-span-2 flex items-center mt-4"></status-toogle-button>
                    <div class="sm:col-span-6">
                        <label class="block text-sm font-medium text-gray-700 dark:text-gray-400">Address <span
                                class="custom-error">*</span></label>
                        <div class="mt-1 rounded-md border border-gray-300 p-3">
                            <div class="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
                                <div class="sm:col-span-2">
                                    <label class="block text-sm font-medium text-gray-700 dark:text-gray-400">Choose
                                        Office
                                        Layer <span class="custom-error">*</span></label>
                                    <div class="mt-1">
                                        <!-- <pre>{{ form }}</pre> -->
                                        <select v-model="form.office_layer_id"
                                            class="block w-full rounded-md border-gray-300 shadow-sm focus:border-orange-500 focus:ring-orange-500 sm:text-sm"
                                            required>
                                            <option value=null>Choose One</option>
                                            <option v-for="office_layer in office_layers" :value="office_layer.id">{{
                                                office_layer.office_layer_name }}
                                            </option>
                                        </select>
                                        <div v-if="form.errors.office_layer_id" class="form-error">{{
                                            form.errors.office_layer_id }}</div>
                                    </div>
                                </div>

                                <div class="sm:col-span-2" v-if="form.office_layer_id == 1">
                                    <label class="block text-sm font-medium text-gray-700 dark:text-gray-400">Choose
                                        Ministry <span class="custom-error">*</span></label>
                                    <div class="mt-1">
                                        <!-- <pre>{{ form }}</pre> -->
                                        <select v-model="form.ministry_id"
                                            class="block w-full rounded-md border-gray-300 shadow-sm focus:border-orange-500 focus:ring-orange-500 sm:text-sm"
                                            required>
                                            <option value=null>Choose One</option>
                                            <option v-for="ministry in ministries" :value="ministry.id">{{
                                                ministry.ministry_name }}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                                <div class="sm:col-span-2" v-if="form.office_layer_id > 1">
                                    <label class="block text-sm font-medium text-gray-700 dark:text-gray-400">Choose
                                        Region<span class="custom-error">*</span></label>
                                    <div class="mt-1">
                                        <!-- <pre>{{ form }}</pre> -->
                                        <select v-model="form.region_id"
                                            class="block w-full rounded-md border-gray-300 shadow-sm focus:border-orange-500 focus:ring-orange-500 sm:text-sm"
                                            @change="load_province(1)" required>
                                            <option value=null>Choose One</option>
                                            <option v-for="region in regions" :value="region.id">{{ region.region_name
                                                }}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                                <div class="sm:col-span-2" v-if="form.office_layer_id > 2">
                                    <label class="block text-sm font-medium text-gray-700 dark:text-gray-400">Choose
                                        Province <span class="custom-error">*</span></label>
                                    <div class="mt-1">
                                        <!-- <pre>{{ form }}</pre> -->
                                        <select v-model="form.province_id"
                                            class="block w-full rounded-md border-gray-300 shadow-sm focus:border-orange-500 focus:ring-orange-500 sm:text-sm"
                                            @change="load_municipality(1)" required>
                                            <option value=null>Choose One</option>
                                            <option v-for="province in pre_province_list" :value="province.id">{{
                                                province.provience_name }}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="sm:col-span-2" v-if="form.office_layer_id > 3">
                                    <label class="block text-sm font-medium text-gray-700 dark:text-gray-400">Choose
                                        Municipality <span class="custom-error">*</span></label>
                                    <div class="mt-1">
                                        <select v-model="form.municipality_id"
                                            class="block w-full rounded-md border-gray-300 shadow-sm focus:border-orange-500 focus:ring-orange-500 sm:text-sm"
                                            @change="load_barangay(1)" required>
                                            <option value=null>Choose One</option>
                                            <option v-for="municipality in pre_municipality_list"
                                                :value="municipality.id">
                                                {{ municipality.municipality_name }}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="sm:col-span-2" v-if="form.office_layer_id > 4">
                                    <label class="block text-sm font-medium text-gray-700 dark:text-gray-400">Choose
                                        Barangay <span class="custom-error">*</span></label>
                                    <div class="mt-1">
                                        <select v-model="form.barangay_id"
                                            class="block w-full rounded-md border-gray-300 shadow-sm focus:border-orange-500 focus:ring-orange-500 sm:text-sm"
                                            required>
                                            <option value=null>Choose One</option>
                                            <option v-for="barangay in pre_barangay_list" :value="barangay.id">{{
                                                barangay.barangay_name }}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="sm:col-span-2" v-if="office_selected == true">
                                    <label class="block text-sm font-medium text-gray-700 dark:text-gray-400">Choose
                                        Office <span class="custom-error">*</span></label>
                                    <div class="mt-1">
                                        <select v-model="form.office_id"
                                            class="block w-full rounded-md border-gray-300 shadow-sm focus:border-orange-500 focus:ring-orange-500 sm:text-sm"
                                            required>
                                            <option value=null>Select Office</option>
                                            <option v-for="office in offices" :value='office.id'>{{ office.office_name
                                                }}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="sm:col-span-3 grid grid-cols-2 gap-y-2 gap-x-1 mb-1">
                        <div class="flex items-center col-span-2">
                            <label class="block text-sm font-medium text-gray-700 dark:text-gray-400">Gallery <span
                                    class="custom-error">*</span></label>
                            <Button :name="'Add'" :icon="'far fa-plus-circle'" :method="open_gallery_popup"></Button>
                        </div>
                        <div class="col-span-2 gap-y-2 gap-x-1 my-1">
                            <gallery-view :galleries="form.galleries" @UpdateGalleryList="update_gallery_list" />
                        </div>
                        <div class="col-span-2">
                            <gallery :galleries="form.galleries" :galleryopen="galleryopen"
                                @UpdateGalleryPopup="update_gallery_popup" @UpdateGallery="update_gallery">
                            </gallery>
                        </div>
                        <div v-if="form.errors.galleries" class="form-error">Gallery required.</div>
                    </div>
                </div>
                <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
                    <Button v-if="permission.edit > 0" :type="type" :name="head" :url="createUrl"
                        :loading="form.processing"></Button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import { Head, Link, useForm } from '@inertiajs/inertia-vue3'
import { ref, toRefs, inject, onMounted, watch } from 'vue'
import axios from 'axios';
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import TextareaInput from '@/Shared/TextareaInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import Breadcrumbs from '@/Shared/Breadcrumbs'
import StatusToogleButton from '@/Shared/StatusToogleButton'
import Button from '@/Shared/Button'
import PhotoBlock from './Photo'
import Gallery from './components/Gallery';
import GalleryView from './components/GalleryView';

export default {
    components: {
        Head,
        Link,
        LoadingButton,
        SelectInput,
        TextInput,
        Breadcrumbs,
        StatusToogleButton,
        Button,
        TextareaInput,
        PhotoBlock,
        Gallery,
        GalleryView,
    },
    layout: Layout,
    props: {
        regions: Array,
        hosts: Array,
        resident: Object,
        ministries: Array,
        offices: Array,
        office_layers: Array,
        permission: Array,
        host_id: Number,
        user_role: Number,
    },
    remember: 'form',
    setup(props) {
        const backendPrefix = ref(process.env.MIX_ADMIN_PREFIX)
        const { resident, permission, regions, hosts, ministries, office_layers, host_id, user_role } = toRefs(props)
        const type = ref('edit')
        const title = ref(resident.value.title)
        const head = ref('Resident')
        const url = ref('/backend/tourist-residents')
        const createUrl = ref('')
        const amenityopen = ref(false)
        const attachmentopen = ref(false)
        const categoryopen = ref(false)
        const keywordopen = ref(false)
        const property_typeopen = ref(false)
        const roomopen = ref(false)
        const metaopen = ref(false)
        const galleryopen = ref(false)
        const accessoriesopen = ref(false)
        const activitytypeopen = ref(false)
        const sel_room_accessories = ref([])
        const sel_room_index = ref('')
        const cantime = ref('')
        const offices = ref([])
        const office_selected = ref(false)
        const host_selected = ref(false)
        const swal = inject('$swal')
        const elm = ref(this)
        const form = useForm({
            title: resident.value.title,
            slug: resident.value.slug,
            desc: resident.value.desc,
            status: resident.value.status,
            longitude: resident.value.longitude,
            latitude: resident.value.latitude,
            google_address: resident.value.google_address,
            host_id: resident.value.host_id,
            region_id: resident.value.region_id,
            province_id: resident.value.province_id,
            municipality_id: resident.value.municipality_id,
            barangay_id: resident.value.barangay_id,
            map_embedded: resident.value.map_embedded,
            office_layer_id: resident.value.office_layer_id,
            office_id: resident.value.office_id,
            ministry_id: resident.value.ministry_id,
            email: resident.value.email,
            mobile: resident.value.mobile,
            image_path: resident.value.image_path,
            galleries: resident.value.galleries ? resident.value.galleries : [],
        })
        const update = () => {
            swal({
                title: 'Are you sure?',
                text: "You want to proceed with this action",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Confirm',
                cancelButtonText: 'Cancel',
            }).then((result) => {
                if (result.isConfirmed) {
                    form.put(`${url.value}/${resident.value.id}`)
                    title.value = resident.value.title
                    swal.fire(
                        'Updated!',
                        'Your infomation has been Updated.',
                        'success'
                    )
                }
            });
        }
        const destroy = () => {
            swal({
                title: 'Are you sure?',
                text: "Do you really want to delete this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
                if (result.isConfirmed) {
                    form.delete(`${url.value}/${resident.value.id}`)
                    swal.fire(
                        'Deleted!',
                        'Your infomation has been deleted.',
                        'success'
                    )
                }
            });
        }
        const restore = () => {
            swal({
                title: 'Are you sure?',
                text: "You want to restore this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, Resore it!'
            }).then((result) => {
                if (result.isConfirmed) {
                    form.put(`${url.value}/${resident.value.id}/restore`)
                    swal.fire(
                        'Restored!',
                        'Your infomation has been Restored.',
                        'success'
                    )
                }
            });
        }

        const pre_province_list = ref([])

        const load_province = async (req_for) => {

            let data = {
                geo_region_id: req_for == 2 ? form.region_id : form.region_id
            }
            await axios.post(`/${backendPrefix.value}/provinces/activeprovinces`, data)
                .then(function (response) {
                    pre_province_list.value = response.data
                    if (req_for != 2) {
                        form.province_id = null
                        form.municipality_id = null
                        form.barangay_id = null
                        if (form.province_id) load_municipality()
                    } else {
                        if (form.province_id) load_municipality(2)
                    }
                }.bind(this));
        }
        const pre_municipality_list = ref([])
        const load_municipality = async (req_for) => {
            let data = {
                geo_provience_id: req_for == 2 ? form.province_id : form.province_id
            }
            await axios.post(`/${backendPrefix.value}/municipalities/activemunicipalities`, data)
                .then(function (response) {
                    pre_municipality_list.value = response.data
                    if (req_for != 2) {
                        form.municipality_id = null
                        form.barangay_id = null
                        if (form.municipality_id) load_barangay()
                    } else {
                        if (form.municipality_id) load_barangay(2)
                    }
                }.bind(this));
        }

        const pre_barangay_list = ref([])
        const load_barangay = async (req_for) => {
            let data = {
                geo_municipality_id: req_for == 2 ? form.municipality_id : form.municipality_id
            }
            await axios.post(`/${backendPrefix.value}/barangays/activebarangays`, data)
                .then(function (response) {
                    pre_barangay_list.value = response.data
                    if (req_for != 2) {
                        form.barangay_id = null
                    }

                }.bind(this));
        }

        const get_office_data = () => {
            let data1 = {
                office_layer_id: form.office_layer_id,
                ministry_id: form.ministry_id,
                geo_region_id: form.region_id,
                geo_province_id: form.province_id,
                geo_municipality_id: form.municipality_id,
                geo_barangay_id: form.barangay_id,
            }
            axios.post(`/${backendPrefix.value}/geomapping/load-offices`, { data: data1 })
                .then(function (response) {
                    offices.value = response.data;
                    office_selected.value = true;
                })
        }

        const setHostData = () => {
            if (user_role.value != 1 && user_role.value != 10) {
                host_selected.value = true
            }
        }
        const slugBuild = () => {
            form.slug = form.title.replace(/\s/g, '-').toLowerCase()
        }

        const set_photo = (val) => {
            form.image_path = val
        }

        const update_gallery_popup = (val) => {
            galleryopen.value = val
        }
        const update_gallery = (val) => {
            form.gallery = val
        }
        const update_gallery_list = (val) => {
            form.gallery = val
        }

        const open_gallery_popup = () => {
            galleryopen.value = true
        }

        watch(() => [form.office_layer_id, form.ministry_id, form.region_id, form.province_id, form.municipality_id, form.barangay_id], () => {
            get_office_data();
        }, { deep: true })

        onMounted(() => {
            load_province(2)
            load_municipality(2)
            load_barangay(2)
            setHostData()
            get_office_data()
            cantime
        })

        return {
            form,
            resident,
            type,
            title,
            url,
            createUrl,
            update,
            regions,
            head,
            hosts,
            permission,
            pre_province_list,
            pre_municipality_list,
            pre_barangay_list,
            load_municipality,
            load_province,
            load_barangay,
            backendPrefix,
            offices,
            ministries,
            office_layers,
            get_office_data,
            office_selected,
            slugBuild,
            user_role,
            set_photo,
            host_id,
            host_selected,
            galleryopen, open_gallery_popup, update_gallery_popup, update_gallery,
        }
    }
}
</script>
<style lang="scss" scoped>
$button_height: 36;

.profile_edit_content_block {
    display: block;

    .edit_form_block {
        background-color: #ffffff80;

        textarea,
        select {
            width: 100%;
            border: 1px solid #ddd;
            padding: 5px 10px;
            border-radius: 5px;
        }

        .item_block:hover>div i {
            display: flex !important;
        }

        i {
            width: 30px;
            text-align: center;
            transition: all 0.4s;
            position: absolute;
            margin-right: 0px !important;
            top: 15px;
            font-size: 10px;
            display: none;
            cursor: pointer;

            &.active {
                display: flex !important;
            }

            &.del {
                position: absolute;
                width: 20px;
                height: 20px;
                display: flex;
                align-items: center;
                justify-content: center;
                background: #fff;
                border-radius: 50%;
                box-shadow: 0 0 5px #999;
                border: 1px solid #ddd;
                cursor: pointer;
                top: -5px;
                right: -5px;
            }
        }



        .err_msg {
            border-color: #CD0000 !important
        }

        .c-list {
            background: #006699;
            color: #fff;
            padding: 5px 7px;
            border-radius: 15px;
            font-size: 11px;
            max-height: 24px;
        }
    }
}

.save_btn,
.cancel_btn {
    height: #{$button_height}px;
    background-color: #0f8050;
    color: #fff;
    cursor: pointer;
    border-radius: 5px;

    &.cancel_btn {
        border: 1px solid #CD0000;
        color: #CD0000;
        background-color: #fff;
    }
}

.dark {
    .profile_edit_content_block {

        input,
        textarea,
        select {
            background-color: #222;
        }
    }
}

.password_block,
.confirm_password_block {
    p {
        align-items: baseline;
        color: #666;
        display: flex;
        gap: 5px;
        font-size: 10px !important;

        span {
            color: gold !important;
            font-size: 10px !important;
        }
    }

}
</style>
